
export const CHECKOUT_URL =
  'https://mega-pack-kinesiologia.impultienda.ar/checkout'
export const OFFER = {
  packId: 'atlas-clinico',
  packName: 'Atlas Clínico — Sistema Completo de Evaluación Clínica',
  value: 12.99,
  currency: 'USD',
}
